import { Box } from "@mui/material";

interface LogoProps {
  size?: number;
}

function Logo({ size = 48 }: LogoProps) {
  return (
    <Box
      component="img"
      src={`${process.env.PUBLIC_URL}/logo.png`}
      alt="Aprende+"
      sx={{ width: size, height: size, borderRadius: "50%", bgcolor: "#fff", objectFit: "contain", display: "block" }}
    />
  );
}

export default Logo;
